/** Atributos do input de busca das combos (ng-select e autocompletes customizados). */
export const COMBO_INPUT_ATTRS: Readonly<Record<string, string>> = {
  autocomplete: 'off',
  autocorrect: 'off',
  autocapitalize: 'off',
  spellcheck: 'false',
};
